<template>
  <div class="bg" :height="fullHeight" :width="fullWidth">
    <spinner v-if="isLoading" />
    <b-container>
     <b-row>
        <b-col
          cols="12"
          md="8"
          offset-md="2"
          lg="6"
          offset-lg="3"
        >
          <b-card
            img-alt="Image"
            img-top
            tag="article"
            class="mb-2 shadow-sm p-2 mb-2 bg-white rounded"
          >
            <b-card-text class="w-100 text-center">
              <b-img :src="logo" fluid alt="Logo Evento" class="mb-3"></b-img>
              <h3> {{ this.mensajes[0].valor }}</h3>
              <p class="lead mb-3"> {{ this.mensajes[1].valor }}</p>
              <p><b>Ruta: </b><br> {{ $route.params }}</p>
            </b-card-text>
              <b-button
                type="button"
                variant="danger"
                size="sm"
                block
                @click="returnLobby"
              >
                 {{ this.mensajes[2].valor }}
              </b-button>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Spinner from '@/components/Spinner'
import apiGrals from '../api/config.js'
import {
  BContainer,
  BRow,
  BCol,
  BCard,
  BCardText,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BImg,
  BAlert
} from 'bootstrap-vue'

export default {
  name: 'Mantenimiento',
  components: {
    BContainer,
    BRow,
    BCol,
    BCard,
    BCardText,
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BImg,
    BAlert,
    Spinner
  },
  data () {
    return {
      // Logo
      logo: '',
      isLoading: true,
      fullWidth: document.documentElement.clientWidth,
      fullHeight: document.documentElement.clientHeight,
      curWidth: '',
      curHeight: '',
      idLink: null,
      mensajes: []
    }
  },
  async created () {
    if (!localStorage.getItem('images')) {
      await apiGrals
        .getImages('all')
        .then(x => {
          localStorage.setItem('images', JSON.stringify(x.data))
          this.setImages()
        })
        .catch(e => {
          console.log('Error')
        })
    } else {
      this.setImages()
    }
    this.idLink = this.$route.params.id
    console.log(JSON.stringify(this.$route.params))
    // obtener datos de apigrals desde axios
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
    this.isLoading = false
    // Obtiene datos de los mensajes desde API
    await apiGrals
      .getMensajes(this.$route.params.subnet, 'Mantenimiento')
      .then(x => {
        this.mensajes = x.data
      })
      .catch(e => {
        // Problemas en la consulta de la api
        this.$router.push({ path: '/ErrorSubnet/' + localStorage.getItem('subnet') })
      })
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    validateState (name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    handleResize (event) {
      this.fullWidth = document.documentElement.clientWidth - 2
      this.fullHeight = document.documentElement.clientHeight - 2
      this.curWidth = this.fullWidth + 'px'
      this.curHeight = this.fullHeight + 'px'
    },
    returnLobby () {
      const ruta = '/' + localStorage.getItem('subnet') + '/lobby'
      this.$router.push({ path: ruta })
    },
    // Filter background and buttons
    setImages () {
      // Obtiene la lista de imagenes de localStorage
      const images = JSON.parse(localStorage.getItem('images'))
      // Filtra logotipo del eventos
      let image = images.filter(image => image.keyitem === 'logo')
      this.logo = image[0].image
    }
  }
}
</script>

<style scoped>
.bg {
  background-color: #f6f7f8;
  height: 100vh;
  display: flex;
  align-items: center;
}
.fullheight {
  min-height: 100vh;
  overflow: hidden;
}
/*  Pone manita a todas las areas*/
area {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Mantenimiento.vue